import { combineReducers } from "redux";
import postReducer from "./post-reducer";

export default combineReducers({
  home: postReducer,
});
